import React, { memo, useMemo } from "react";
import { ListGroup, ListGroupItem, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useHtmlClassService } from "../../_core/MetronicLayout";

export default memo(function Footer() {
  const today = new Date().getFullYear();

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-3 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <Row className="align-items-center w-100">
          <Col md={6}>
            <div className="text-dark order-2 order-md-1 text-center text-md-left">
              <span className="text-muted font-weight-bold mr-2">
                {today.toString()}
              </span>{" "}
              &copy;{" "}
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-dark-75 text-hover-primary"
              >
                equipbid
              </a>
            </div>
          </Col>
          <Col
            md={6}
            className="lastFooterLinks d-flex justify-content-center justify-content-md-end mt-2 mt-md-0"
          >
            <ListGroup horizontal>
              <ListGroupItem>
                <Link to="" className="text-dark-75 text-hover-primary">
                  Terms & Conditions
                </Link>
              </ListGroupItem>
              <ListGroupItem>
                <Link to="" className="text-dark-75 text-hover-primary">
                  Privacy Policy
                </Link>
              </ListGroupItem>
            </ListGroup>
          </Col>
        </Row>
      </div>
    </div>
  );
});
